<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="讲师等级：">
            <el-input v-model="query.name" placeholder="请输入讲师等级名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建等级</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="讲师等级" prop="name" align="center" />
        <el-table-column label="描述" prop="described" align="center" />
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="160px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 新建表单 -->
    <lecturerLevel-add ref="lecturerLevelAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import lecturerLevelAdd from './add'
import lecturerLevelApi from '@/api/course/lecturerLevel'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    lecturerLevelAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        name: undefined,
        isEnable: undefined,
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    handleFilter(){
      this.query = {}
      this.doQueryList({ pageNo: 1,pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList()
    },
    /**
     * 执行列表查询
     */
    doQueryList() {
      this.listLoading = true
      return lecturerLevelApi.fetchList(this.query)
        .then(({ data }) => {
          this.list = data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => lecturerLevelApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => lecturerLevelApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      lecturerLevelApi.setIsEnable({ id: row.id, isEnable: row.isEnable}).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      questionsApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.lecturerLevelAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.lecturerLevelAdd.handleUpdate(row)
    }
  }
}
</script>
